import React from "react";
import { Card, CardBody } from "@windmill/react-ui";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";

const SalesCardItemOne = ({
  card_bg_color,
  title,
  Icon,
  Img,
  quantity,
  amount,
  className,
  loading,
  mode,
  pending,
  todayPending,
  olderPending,
  onNavigation,
  type,
  passDates,
  current_month,
  partially_status,
  agent_status,
  cardtype,
  daytitle,
   todatonext30days
}) => {

  const history = useHistory();
  const handleNavigate = () => {
    const params = new URLSearchParams();
    if (type != null) params.append("type", type);
    const format = (d) =>
      d.toLocaleDateString("en-GB").split("/").join("-");
    const today = new Date();
    if (current_month) {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      params.append("start", format(start));
      params.append("end", format(end));
    }
    if (passDates) {
      params.append("start", format(today));
      params.append("end", format(today));
    }
    if (cardtype) {
      params.append("cardtype", cardtype)
    }
    if (partially_status) {
      params.append("status", "partial");
    }
    if (agent_status) {
      params.append("agentstatus", "Inactive")
    } if (todatonext30days) {
      const later = new Date(today);
      later.setDate(today.getDate() + 30);
      params.append("start", format(today));
      params.append("end", format(later));
    }
    history.push({
      pathname: onNavigation,
      search: params.toString() ? `?${params}` : "",
    });
  };


  return (
    <>
      {loading ? (
        <Skeleton
          count={2}
          height={40}
          className="dark:bg-gray-800 bg-[#D7FFDE]"
          baseColor={mode === "dark" ? "#010101" : "#f9f9f9"}
          highlightColor={mode === "dark" ? "#1a1c23" : "#f8f8f8"}
        />
      ) : (
        <Card className="h-full" style={{ backgroundColor: card_bg_color }} onClick={() => handleNavigate()}>
          <CardBody className="cursor-pointer flex flex-col justify-between rounded-lg p-4">
            <div className="flex justify-between items-center mb-3">
              <h6 className={`text-lg font-medium text-black-600 dark:text-black-400 ${className || ""}`}>
                {title}{" "}
                {amount && (
                  <span className="text-red-500 text-sm font-semibold ml-1">
                    ({parseFloat(amount).toFixed(2)})
                  </span>
                )}
              </h6>
              {Icon ? (
                <div className="p-3 rounded-full h-12 w-12 flex items-center justify-center text-lg">
                  <Icon />
                </div>
              ) : Img ? (
                <img
                  src={Img}
                  alt={title}
                  className="object-contain"
                  style={{ width: "35px", height: "auto" }}
                  draggable={false}
                />
              ) : null}
            </div>

            <div className="flex items-baseline justify-between mt-3">

              <p className="text-3xl font-extrabold text-black-600 dark:text-black-200 mt-2 mb-0">
                {quantity}
              </p>
              <p className="mb-0" style={{ fontSize: "16px", fontWeight: "600", color: "#3B82F6" }}>{daytitle}</p>
            </div>



            {pending && (
              <div className="grid grid-cols-2 gap-4 mt-4 text-sm font-medium text-gray-600 dark:text-gray-400">
                <div>
                  <span className="font-semibold">Today</span>{" "}
                  <span className="text-green-600 font-semibold">
                    ({parseFloat(todayPending || 0).toFixed(2)})
                  </span>
                </div>
                <div>
                  <span classNam
                    e="font-semibold">Older</span>{" "}
                  <span className="text-orange-400 font-semibold">
                    ({parseFloat(olderPending || 0).toFixed(2)})
                  </span>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default SalesCardItemOne;
